export default __webpack_public_path__ + "static/media/star-filled.8fb497fd.svg";